import styled from "styled-components";

export const H2Hidden = styled.h2(({ }) => ({
    visibility: "hidden"
}));